<template lang="pug">
.v-small-slider.small-slider(v-if="data" :key="isTablet" :id="data?.id")
	v-base-slider(:options="computedOptions")
		v-swiper-slide.swiper-slide(v-for="slide in data.items")
			.small-slider__slide(:style="{backgroundImage: `url('${slide.backgroundImage}')`, backgroundColor: slide.backgroundColor}")
				.small-slider__slide-title(v-if="slide.title") {{slide.title}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";
import {SwiperSlide} from 'swiper/vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	components: {
		'v-swiper-slide': SwiperSlide
	},

	data() {
		return {
			data: null
		}
	},

	computed: {
		computedOptions() {
			return {
				delay: 3000,
				autoplay: !this.isTablet,
				watchOverflow: true,
				slidesPerView: 1,
				spaceBetween: 11,
				resizeObserver: true,
				loop: false,
				pagination: {
					clickable: true,
					dynamicBullets: false
				}
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>